<script setup lang="ts">
import {
  TabsRoot,
  TabsRootEmits,
  TabsRootProps,
  useForwardPropsEmits,
} from 'radix-vue'

const props = defineProps<TabsRootProps<string | number>>()
const emits = defineEmits<TabsRootEmits<string | number>>()
const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <TabsRoot
    v-bind="forwarded"
    class="flex w-full flex-col gap-1"
  >
    <slot></slot>
  </TabsRoot>
</template>
